<template>
  <w-select class="mt4" :items="d_tahun" label="Tahun"  v-model="carian.tahun" @input="getData(2)"/><br>
  <div class="dashboard1">
    <div class="cardp" v-for="card in cards2" :key="card.id" @click="item(card.item)">
      <div class="card-icon">
        <h2>{{ card.title }}</h2>
      </div>
      <div class="card-info2">
       <p>{{ card.count }}</p>
      </div>
    </div>
  </div>
  <br>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  props: {
    d_tahun: [Array, Object],
  },
  name: "SeIbvk",
  components: {
        GChart
  },
  data() {
    return {
      cards: [
        { id: 1, title: 'DRAFT', count: 1500, icon: 'fas fa-users' },
        { id: 2, title: 'HANTAR', count: 1200, icon: 'fas fa-user-check' },
        // { id: 3, title: 'PROSES', count: 300, icon: 'fas fa-user-plus' },
      ],
      cards2:[],
      carian: { tahun: "" },
    }
  },
  methods:{
    getData(item){
      if(item==1){
        var today = new Date();
        this.carian.tahun = today.getFullYear(); 
      }
      this.$zcomm.get(this.api_service + 'dashboard/permohonan-ibvk/2?tahun='+this.carian.tahun, {}).then(res => {
        this.cards2 = res
      })
    },
    item(id){
      window.location.href = window.route('embrio.permohonan.ibvk.index')+'?status='+id;
    },
    getCardClass(id) {
      return `cardse-${id}`;
    },
  },
      
  mounted() {
    this.getData(1)
  }
}
      

</script>  
<style type="text/css">
    .dashboard1 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  padding: 20px;
  background-color: #f5f5f5;
}

.cardp {
  background: linear-gradient(135deg, #42a5f5, #478ed1);
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
}

.cardp:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.card-icon {
  font-size: 60px;
  margin-bottom: 15px;
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.3s;
}

.cardp:hover .card-icon {
  color: #fff;
}

.card-info2 h2 {
  margin: 0;
  font-size: 18px;
  margin-right: 95px;
  font-weight: bold;
  color: #f1f1f1;
  letter-spacing: 1px;
}

.card-info2 p {
  margin-top: 8px;
  margin-right: 95px;
  font-size: 60px;
  font-weight: bold;
  color: #fff;
}

.cardp:nth-child(1) {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(218 197 6)), url(/images/p-mohon.png) center / cover no-repeat;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
/*  background: linear-gradient(135deg, #ea1e1e, #e15252);*/
}
.cardp:nth-child(3) {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(57 178 44)), url(/images/p-lulus.png) center / cover no-repeat;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
/*  background: linear-gradient(135deg, #ea1e1e, #e15252);*/
}
.cardp:nth-child(2) {
  background: linear-gradient(135deg, rgb(254 154 23 / 7%), rgb(175 20 20)), url(/images/p-tolak.png) center / cover no-repeat;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
/*  background: linear-gradient(135deg, #ea1e1e, #e15252);*/
}
</style>
